export default "__VITE_ASSET__Dpf324Gr__"